import {i18n} from 'src/shared/config'

export function getFallbackValue(value: string) {
  return i18n(`cargo.create.cargo-image-requirement.${value}`, {fallBackToKey: false})
}
